import { render, staticRenderFns } from "./SearchResultProducts.vue?vue&type=template&id=49245e9a"
import script from "./SearchResultProducts.vue?vue&type=script&lang=js"
export * from "./SearchResultProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports